module.exports = __webpack_public_path__ + "static/t-com-bw-41b1409ee05b96f8e86c4fca4d24692b.jpg";